<template>
  <div class="tab-menu">
    <h3 class="tab-menu__head">Utility:</h3>
    <div class="tab-menu__dropdown" :class="{ 'tab-menu__dropdown--single-child' : utilities.length === 0 }">
      <ul class="tab-menu__list">
        <li class="tab-menu__item">
          <button class="tab-menu__option" v-if="dashboardSortUtility">{{ dashboardSortUtility.name }}: <b>{{ dashboardSortUtility.plan.name }}</b></button>
          <button class="tab-menu__option" v-else> &ndash; No Utility Selected &ndash; </button>
        </li>
        <li class="tab-menu__item" v-for="utility in dropDownUtilities">
          <button class="tab-menu__option" @click="sortByUtility(utility)">{{ utility.name }}: <b>{{ utility.plan.name }}</b></button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  computed: {
    userPlan() {
      return this.$store.getters.userPlan
    },
    userId() {
      return this.$store.getters.userId
    },
    dashboardSortUtility() {
      if (this.$store.getters.dashboardSortUtility) {
        return this.$store.getters.dashboardSortUtility
      }
    },
    savedPricingRequestUtilities() {
      return this.$store.getters.savedPricingRequestUtilities
    },
    savedPricingRequests() {
      return this.$store.getters.savedPricingRequests
    },
    savedRegisteredPricingRequests() {
      let pricingRequests = this.savedPricingRequests

      return pricingRequests.filter(pricingRequest => pricingRequest.inputs.utility.plan.slug === 'free-registered')
    },
    utilitiesRaw() {
      return this.$store.getters.userUtilities
    },
    utilities() {

      // All active utilities.
      let utilities = this.utilitiesRaw.filter(utility => utility.plan.slug === this.userPlan.slug)

      // If the user isn't subscribed to a paid plan, then reset the array.
      if (this.userPlan.slug === 'free-registered') {
        utilities = []
      }

      let utilityIds = utilities.map(utility => utility.id)

      // Include any utilities for which the user has a saved price request.
      if (this.savedPricingRequestUtilities) {
        for (let i = 0; i < this.savedPricingRequestUtilities.length; ++i) { 

          // Only include if not already included.
          if (! utilityIds.includes(this.savedPricingRequestUtilities[i].id)) {
            utilities.push(this.savedPricingRequestUtilities[i])
            utilityIds.push(this.savedPricingRequestUtilities[i].id)
          }
        }
      }

      return utilities
    },
    dropDownUtilities() {
      // Filter out the currently-selected utility so that it only 
      // appears once at the top (as the selected tab).
      if (this.dashboardSortUtility && this.dashboardSortUtility.id) {
        return this.utilities.filter(utility => utility.id != this.dashboardSortUtility.id)
      }

      return this.utilities
    }
  }, 
  methods: {
    sortByUtility(utility) {

      this.$emit('setDashboardSortUtility', utility)

      localStorage.setItem('epb_utility_sort', JSON.stringify(utility))
      localStorage.setItem('epb_uid', this.userId)
    },
    sortByUtilityId(id) {
      let results = this.utilities.filter(utility => {
        return utility.id == id
      })
      
      if (results.length) {
        this.sortByUtility(results[0])
      }
    }
  },
  mounted() {

    // Set the current utility.
    let currentUtility

    if (this.userPlan.slug != 'free-registered') {

      // Load previous sort utility from localstorage.
      if (localStorage.getItem('epb_utility_sort')) {
        
        // Make sure the previous sort utility belonged to this user.
        if (localStorage.getItem('epb_uid') && localStorage.getItem('epb_uid') == this.userId) {
          let savedSortUtility = JSON.parse(localStorage.getItem('epb_utility_sort'))
          let filteredUtilities = this.utilities.filter(utility => utility.id == savedSortUtility.id)

          if (filteredUtilities.length) {
            currentUtility = savedSortUtility
            this.sortByUtility(savedSortUtility)
          }
        }
      }
    }

    // Fallback to the first loaded utility.
    if (! currentUtility && this.utilities.length) {
      this.sortByUtility(this.utilities[0])
    }

    // If highlighting a pricing row via "uiid" URL query param (user_inputs id),
    // make sure that the correct utility is selected.
    setTimeout(() => {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.has('uiid')) {
        const priceRequests = this.$store.getters.savedPricingRequests.filter((priceRequest) => {
          return priceRequest.id == urlParams.get('uiid')
        })

        if (priceRequests.length && priceRequests[0].utility_id) {
          this.sortByUtilityId(priceRequests[0].utility_id)
        }
      }
    }, 500)
  }
}
</script>
